import Loading from '../../../components/Loading'
import Box from '../../../components/Box'
import styles from "./styles.module.css"

function LoadingBox(){
    return(
        <Box className={styles.box}>
            <Loading />
        </Box>
    )
}

export default LoadingBox